import PrimaryButton from '@features/common/components/PrimaryButton';
import { useIntl } from 'react-intl';
import { IOrganizeButtonScrollToFormProps } from '../models/organize-state.model';

const OrganizeButtonScrollToForm = (props: IOrganizeButtonScrollToFormProps) => {
	const { scrollToForm, translationKey } = props;
	const { formatMessage } = useIntl();

	return (
		<div className='flex space-x-3 w-76 lg:w-88 pb-4 z-[4] items-center justify-center'>
			<div className='min-w-[160px] md:min-w-[217px]'>
				<PrimaryButton onClick={scrollToForm} testId='scrollToFormBtn' type='button' tabIndex={3}>
					{formatMessage({ id: translationKey })}
				</PrimaryButton>
			</div>
		</div>
	);
};

export default OrganizeButtonScrollToForm;
